// extracted by mini-css-extract-plugin
export default {"mention":"CommentMessage_mention__dvsJ0"};